import { ReactSelectOption } from '../types/projectTypings';

export enum THEMES {
  DARK = 'dark',
  LIGHT = 'light'
}

export const APP = {
  name: 'worklage',
  displayName: 'Worklage',
  source: 'app',
  url: 'https://www.worklage.com',
  api: 'https://api.worklage.com',
  socket: 'wss://api.worklage.com',
  files: 'https://cdn.worklage.com/surgy/',
  play_store_url: 'http://bit.ly/wl-play',
  terms_of_use_url: 'https://www.worklage.com/terms-of-use',
  privacy_policy_url: 'https://www.worklage.com/privacy-policies',
  logo_url: 'https://www.worklage.com/logo.png',
  banner_url: 'https://www.worklage.com/banner.jpg',
  title: 'Enterprise Intranet Solution',
  description:
    'Worklage provides Enterprise Intranet Solution, where you can manage employees, Share updates, Track projects and assets, Messaging and calling between employess, which will ebable better collaboration, productivity and Employee retention.'
};

export enum REACTIONS {
  SMILE = 'SMILE',
  TEARS = 'TEARS',
  BLUSH = 'BLUSH',
  SAD = 'SAD',
  ANGRY = 'ANGRY',
  HEART = 'HEART',
  OK = 'OK',
  SUPER = 'SUPER',
  CLAP = 'CLAP',
  HANDS = 'HANDS'
}

export const reactions = [
  { name: REACTIONS.SMILE, icon: '😀' },
  { name: REACTIONS.TEARS, icon: '😂' },
  { name: REACTIONS.BLUSH, icon: '😳' },
  { name: REACTIONS.SAD, icon: '😭' },
  { name: REACTIONS.ANGRY, icon: '😡' },
  { name: REACTIONS.HEART, icon: '💖' },
  { name: REACTIONS.OK, icon: '👍' },
  { name: REACTIONS.SUPER, icon: '👌' },
  { name: REACTIONS.CLAP, icon: '👏' },
  { name: REACTIONS.HANDS, icon: '🙏' }
];

export enum COLOR_NAMES {
  RED = 'RED',
  ORANGE = 'ORANGE',
  YELLOW = 'YELLOW',
  GREEN = 'GREEN',
  CYAN = 'CYAN',
  BLUE = 'BLUE',
  INDIGO = 'INDIGO',
  PURPLE = 'PURPLE',
  PINK = 'PINK'
}

export const COLORS = {
  [COLOR_NAMES.RED]: { light: '#fecaca', dark: '#dc2626' },
  [COLOR_NAMES.ORANGE]: { light: '#fed7aa', dark: '#ea580c' },
  [COLOR_NAMES.YELLOW]: { light: '#fef9c3', dark: '#947103' },
  [COLOR_NAMES.GREEN]: { light: '#bbf7d0', dark: '#16a34a' },
  [COLOR_NAMES.CYAN]: { light: '#a5f3fc', dark: '#0891b2' },
  [COLOR_NAMES.BLUE]: { light: '#bfdbfe', dark: '#2563eb' },
  [COLOR_NAMES.INDIGO]: { light: '#c7d2fe', dark: '#4f46e5' },
  [COLOR_NAMES.PURPLE]: { light: '#e9d5ff', dark: '#9333ea' },
  [COLOR_NAMES.PINK]: { light: '#f5d0fe', dark: '#c026d3' }
};

export enum CURRENCIES {
  INR = '₹',
  USD = '$',
  EUR = '€',
  POUND = '£',
  YEN = '¥',
  FRANC = '₣'
}

export const ASSET_TAGS = ['Tangible', 'Intangible', 'Digital', 'Electronics', 'Accessories'];

export const ASSETS_TAG_OPTIONS = ASSET_TAGS.map((tag: string) => ({ label: tag, value: tag })) as ReactSelectOption[];

export const FORM_TAGS = ['Public', 'Private', 'Urgent', 'Optional', 'Mandatory', 'Information'];

export const FORMS_TAG_OPTIONS = FORM_TAGS.map((tag: string) => ({ label: tag, value: tag })) as ReactSelectOption[];

export const DOCUMENT_TAGS = ['General', 'Public', 'Private', 'Bills', 'Orders', 'Payslips'];

export const DOCUMENT_TAG_OPTIONS = DOCUMENT_TAGS.map((tag: string) => ({ label: tag, value: tag })) as ReactSelectOption[];

export const reportTypes = [
  'Harassment',
  'Fraud or Scam',
  'Spam or Misinformation',
  'Hateful speech',
  'Threats or Violence',
  'Self harm or Dangerous',
  'Sexual content',
  'Fake content',
  'Child exploitation',
  'Other'
];
